export default "__VITE_ASSET__DrP37$2h__"